import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '@src/app/shared/services/session.service';

interface TransformedLanguage {
  id: number;
  language: string;
  code: string;
}

@Pipe({
    name: "languagePipe",
    standalone: false
})
export class LanguagePipe implements PipeTransform {
  languages: TransformedLanguage[] = [];

  constructor(
    private session: SessionService,
    public translate: TranslateService) {
  }

  private getLanguages() {
    const languages = this.session.companySettings?.languages ?? [];
    const enabledLanguages = languages.filter(language => language.isEnabled);

    const translation = this.translate.instant('PORTAL_LANGUAGES');
    const transformedLanguages = enabledLanguages.map(lang => {
      const code = lang.code ?? 'unknown';
      const languageName = lang.name ?? 'Unknown';

      if (!code || code === 'unknown') {
        console.warn(`Language code is missing or invalid for language: ${languageName}`);
      }

      return {
        id: lang.id ?? 0, // 0 if id is not present
        language: translation[code.toUpperCase()],
        code: code
      };
    });

    this.languages = transformedLanguages;
  }

  transform(key: string | null | undefined): string {
    if (!key) {
      return 'Unknown Language';
    }

    if (this.languages.length === 0) {
      this.getLanguages();
    }

    const language = this.languages.find(
      lang => lang.code?.toLowerCase() === key.toLowerCase()
    );

    if (language) {
      return language.language;
    }

    console.warn(`Language not found for code: ${key}`);
    return 'Unknown Language';
  }
}
